import { useLocation } from "react-router-dom";
import { AIDrawer, FloatingAI } from "@/components/AIDrawer";
import { ProfileDrawer } from "@/components/ProfileDrawer";
import { AuthModal } from "@/components/AuthModal";
import { BuildHuntModal } from "@/components/BuildHuntModal";
import { GearLockerModal } from "@/components/GearLockerModal";

export function GlobalOverlays() {
  const { pathname } = useLocation();
  // The public overlays (AI widget, auth modal, etc.) must not appear inside the
  // private admin portal or the password-reset screen.
  if (pathname.startsWith("/admin") || pathname.startsWith("/reset-password")) return null;
  return (
    <>
      <FloatingAI />
      <AIDrawer />
      <ProfileDrawer />
      <AuthModal />
      <BuildHuntModal />
      <GearLockerModal />
    </>
  );
}
